import React from 'react';
import { Handle, Position } from 'reactflow';
import PropTypes from 'prop-types';
import { Main } from './styles';
import { IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

export const CompanyCard = ({data}) => {
  const {name, slug, result, isExpanded, onToggleExpand, hasChildren} = data
  return (
    <Main style={{
        marginInline: 'auto',
        border: '2px solid #2196f3',
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        minWidth: '200px',
        padding: '16px'
      }}>
      <h1 style={{
        textAlign: 'center', 
        margin: '0 0 12px 0',
        color: '#2196f3',
        fontSize: '18px',
        fontWeight: 'bold'
      }}>{name}</h1>
      <hr style={{border: '1px solid #e0e0e0', margin: '8px 0'}}/>
      <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '8px'}}>
        <p style={{margin: 0, fontSize: '14px', color: '#666'}}>Áreas</p>
        <span style={{fontWeight: 'bold', color: '#2196f3'}}>{result?.areas || 0}</span>
      </div>
      <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '8px'}}>
        <p style={{margin: 0, fontSize: '14px', color: '#666'}}>Processos</p>
        <span style={{fontWeight: 'bold', color: '#e91e63'}}>{result?.processes || 0}</span>
      </div>
      <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '8px'}}>
        <p style={{margin: 0, fontSize: '14px', color: '#666'}}>Sistemas</p>
        <span style={{fontWeight: 'bold', color: '#00bcd4'}}>{result?.systems || 0}</span>
      </div>
      <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '8px'}}>
        <p style={{margin: 0, fontSize: '14px', color: '#666'}}>Ativos</p>
        <span style={{fontWeight: 'bold', color: '#4caf50'}}>{result?.assets || 0}</span>
      </div>
      
      {hasChildren && (
        <div style={{display: 'flex', justifyContent: 'center', marginTop: '8px'}}>
          <IconButton 
            onClick={onToggleExpand}
            size="small"
            style={{
              backgroundColor: '#f5f5f5',
              border: '1px solid #ddd',
              borderRadius: '50%',
              padding: '4px'
            }}
          >
            {isExpanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
          </IconButton>
        </div>
      )}
      <Handle 
        type="source" 
        position={Position.Bottom} 
        id={`${slug}-0`}
        style={{
          background: '#2196f3',
          width: '12px',
          height: '12px',
          border: '2px solid #fff'
        }}
      />
    </Main>
  );
};

CompanyCard.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    slug: PropTypes.string,
    result: PropTypes.object,
    isExpanded: PropTypes.bool,
    onToggleExpand: PropTypes.func,
    hasChildren: PropTypes.bool
  })
};
